import { axiosEduServer } from "../utils/configAxios";

export const crearProgramaIdioma = (data) => {
  return axiosEduServer.post('/programaidioma', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarProgramaIdioma = (id, data) => {
  return axiosEduServer.put(`/programaidioma/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarProgramaIdioma = (id) => {
  return axiosEduServer.delete(`/programaidioma/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneProgramaIdioma = (id) => {
  return axiosEduServer.get(`/programaidioma/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllProgramaIdiomas = () => {
  return axiosEduServer.get('/programaidioma').then(({ data }) => data).catch((err) => { throw err });
};